import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const IntroImageSection = () => {
  return <section className="py-20 bg-white" data-id="element-2773" data-mp="1xkdr1apei0ga">
      <div className="max-w-6xl mx-auto px-4" data-id="element-2774" data-mp="1xjc4oa2xprj9">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative w-full rounded-2xl overflow-hidden shadow-2xl border border-gray-100" data-id="element-2775" data-mp="1tijrx6uut4i8">
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent z-10 pointer-events-none" data-id="element-2776" data-mp="2cgcxyi0rxuju" />
          <img src="https://cdn.magicpatterns.com/uploads/aoTsHvywXXMciML4dctdGv/InShot_20260104_122316850.jpg" alt="Phone with cracked screen displaying gaslighting message - I never said that, you're literally imagining things" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" decoding="async" data-id="element-2777" data-mp="27h07lnap25ci" />
        </motion.div>
      </div>
    </section>;
};